import React, {PropsWithChildren, useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "../store/hooks";
import {resetAction} from "../store/reducers/commonSlice";
import FeedbackModal from "./modals/FeedbackModal";
import {userAPI} from "../api/user";

const Wrapper = ({children}: PropsWithChildren) => {
    const common = useAppSelector(state => state.common)
    const dispatch = useAppDispatch()

    useEffect(() => {
        setTimeout(() => {
            if (common.error || common.success) {
                dispatch(resetAction())
            }
        }, 3000)
    }, [common.error, common.success, dispatch])

    return (
        <>
            {children}
            {common.success && <FeedbackModal
                data={common.success}
            />}
            {common.error && <FeedbackModal
                data={common.error}
                isError={true}
            />}
        </>
    );
};

export default Wrapper;